/** Never hold an edge frame beyond the depth span or across an unfinished seek. */
export function depthFrameMatches(decoded: number, target: number, duration: number, ready: number): boolean {
  return ready >= 2 && Number.isFinite(target) && target >= 0 && target < duration &&
    Number.isFinite(decoded) && Math.abs(decoded - target) <= 0.075;
}
